import React from 'react'
import { state$ } from '@core/Areas/Quickbet/driver'
import { observeImmutable } from '@core/Components/HOCs'
import { BusyIndicator as BusyIndicatorComponent } from '@mobi/component-library/Feedback/BusyIndicator'

export const BusyIndicator = observeImmutable(state$, ({ record }) => (
  <BusyIndicatorComponent isBusy={record.isBusy} />
))
